<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20ZM10.5 18C14.9183 18 18.5 14.4183 18.5 10C18.5 5.58172 14.9183 2 10.5 2C6.08172 2 2.5 5.58172 2.5 10C2.5 14.4183 6.08172 18 10.5 18ZM6.25634 11.1977C6.55309 10.7319 7.17124 10.5948 7.63703 10.8916L8.90212 11.6975C9.13502 11.8459 9.4441 11.7774 9.59247 11.5445L13.0849 6.06244C13.3817 5.59664 13.9998 5.4596 14.4656 5.75634C14.9314 6.05309 15.0684 6.67124 14.7717 7.13703L10.4733 13.8842C10.1766 14.35 9.5584 14.487 9.09261 14.1903L6.56244 12.5784C6.09664 12.2816 5.9596 11.6635 6.25634 11.1977Z"
      fill="#12A958"
    />
  </svg>
</template>
